import { FormTextField, IFormTextField } from 'shared/components/form';
import { PasswordTextField } from 'shared/components/TextField/PasswordTextField';

interface IFormPasswordTextField extends Omit<IFormTextField, 'password'> {}

export const FormPasswordTextField = ({ ...props }: IFormPasswordTextField) => {
  return <FormTextField component={PasswordTextField} {...props} />;
};
